import { render } from "./FeedbackForm.vue?vue&type=template&id=75a71bbe&scoped=true&ts=true"
import script from "./FeedbackForm.vue?vue&type=script&lang=ts"
export * from "./FeedbackForm.vue?vue&type=script&lang=ts"

import "./FeedbackForm.vue?vue&type=style&index=0&id=75a71bbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a71bbe"]])

export default __exports__